import { simpleSet } from '@r/reducers/utils';

const setCalculationModeProjectName = simpleSet as
  redux.reducers.calculationMode.projects.currentProject.settings.information.projectName;

export const projectName = setCalculationModeProjectName(
  'SET_CALCULATION_MODE_CURRENT_PROJECT_PROJECT_NAME',
  'Test Project'
);
